'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = keyMapFM;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('./FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _intlMethods = require('./intlMethods');

var _intlMethods2 = _interopRequireDefault(_intlMethods);

// factory to create custom `FormattedMessage` components
// `custom` means: using a custom `keyMap`, see @intlMethods for more

function keyMapFM(keyMap) {

  if (process.env.NODE_ENV === 'development') {
    if (typeof keyMap !== 'function') {
      throw new Error('`keyMapFM` expects a function');
    }
  }

  var KMFormattedMessage = (function (_React$Component) {
    function KMFormattedMessage() {
      _classCallCheck(this, _KMFormattedMessage);

      if (_React$Component != null) {
        _React$Component.apply(this, arguments);
      }
    }

    _inherits(KMFormattedMessage, _React$Component);

    var _KMFormattedMessage = KMFormattedMessage;

    _KMFormattedMessage.prototype.render = function render() {
      var _props = this.props;
      var m = _props.message;

      var moreProps = _objectWithoutProperties(_props, ['message']);

      return _react2['default'].createElement(_FormattedMessage2['default'], _extends({
        message: keyMap.call(this, m) }, moreProps));
    };

    KMFormattedMessage = (0, _intlMethods2['default'])(keyMap)(KMFormattedMessage) || KMFormattedMessage;
    return KMFormattedMessage;
  })(_react2['default'].Component);

  return KMFormattedMessage;
}

module.exports = exports['default'];


// WEBPACK FOOTER //
// ./~/react-intl-hoc/lib/keyMapFM.js